module.exports = __webpack_public_path__ + "static/media/close-modal.85cfc2b4.svg";